import { render } from "./WidgetComponent.vue?vue&type=template&id=4b9bfe37&scoped=true"
import script from "./WidgetComponent.vue?vue&type=script&lang=js"
export * from "./WidgetComponent.vue?vue&type=script&lang=js"

import "./WidgetComponent.vue?vue&type=style&index=0&id=4b9bfe37&lang=css"
import "./WidgetComponent.vue?vue&type=style&index=1&id=4b9bfe37&scoped=true&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9bfe37"]])

export default __exports__